import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@inject( Router )
export class Home {
   constructor( router ) {
      this.router = router;
      this.showLoginLink = true; 
   }

   activate() {
      this.loginUrl = '#/login';

      if (this.router.firstName != 'No User') {
         this.showLoginLink = false;
      }
   }
}